import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton loading state for the home quick actions.
 * Always shows 2 skeleton buttons to prevent layout shift when
 * "Register Guest" button appears/disappears based on user role.
 */
export function HomeQuickActionsSkeleton() {
  return (
    <div className="mb-6">
      <div className="grid grid-cols-2 gap-2">
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-full" />
      </div>
    </div>
  );
}
